import { defaultLocaleDateString } from 'core/constants/config.constants'

function formatToSwissFormat(number, forceDecimal = true) {
  // Logic to format the number to Swiss format
  try {
    number = Number(number)
    // Determine if the number is an integer or has decimal places
    const hasDecimal = number % 1 !== 0

    // Define the options for the number format
    const options = {
      minimumFractionDigits: hasDecimal || forceDecimal ? 2 : 0, // Add .00 only if there are decimal values
      maximumFractionDigits: 2, // Ensure no more than two digits after the decimal
    }
    // For example, add thousands separator and adjust decimal places
    return number === 0 ? '0.00' : number.toLocaleString(defaultLocaleDateString, options)
  } catch (error) {
    throw new Error('Error on formatToSwissFormat', error)
  }
}

export { formatToSwissFormat }
